<ng-template rtSelectTrigger let-selectCtrl let-inOverlay="inOverlay">
  <div
    (click)="selectCtrl.toggle(true)"
    class="multiselect-container"
    [class.has-extended-preview]="inOverlay && extendedPreviewInOverlay()"
    [class.is-invalid]="isInvalid()"
    [class.disabled]="disabled()"
    rt-overlay-origin
    #origin="rtOverlayOrigin"
    #multiselectContainer
    tabindex="0"
  >
    @if (!!itemSelector.selected().length) {
      <div
        #selectionContainer
        [rtResizeObserver]="{ initial: true }"
        (resized)="
          (!inOverlay || !extendedPreviewInOverlay()) &&
            onResized($event, multiselectContainer, selectionContainer, moreIndicator)
        "
        class="selection-container"
      >
        @for (
          item of itemSelector.selected();
          track trackByValue(index, item);
          let index = $index
        ) {
          <span
            [style.visibility]="
              (!inOverlay || !extendedPreviewInOverlay()) && hiddenItemIndex === index
                ? 'hidden'
                : 'visible'
            "
          >
            <ng-template
              [ngTemplateOutlet]="selectTemplatesService.selectedItemDirective.templateRef"
              [ngTemplateOutletContext]="{
                $implicit: selectCtrl,
                item: item,
                remove: remove,
                showRemoveIcon: !disabled(),
              }"
            />
          </span>
        }
        <span
          #moreIndicator
          [style.left.px]="moreOffset"
          [style.visibility]="
            (!inOverlay || !extendedPreviewInOverlay()) &&
            itemSelector.selected().length - visibleCount > 0
              ? 'visible'
              : 'hidden'
          "
          class="more-indicator"
        >
          <ng-template
            [ngTemplateOutlet]="
              multiselectFeature.selectedItemCounterDirective?.templateRef ?? null
            "
            [ngTemplateOutletContext]="{
              $implicit: selectCtrl,
              hiddenCount: itemSelector.selected().length - visibleCount,
            }"
          />
        </span>
      </div>
    }
    @if (!itemSelector.selected().length) {
      {{ placeholder() }}
    }
    @if (!disabled()) {
      <div class="indicators">
        @if (!!itemSelector.selected()?.length) {
          @if (!!itemSelector.selected()) {
            <rt-icon-button
              (click)="selectCtrl.clear$.next()"
              variant="plain"
              iconName="close"
              shape="square"
              size="small"
            />
          }
          <span class="divider"></span>
        }
        <rt-icon
          name="arrow-drop-down"
          class="dropdown-indicator"
          [class.dropdown-opened]="selectCtrl.isOpen()"
        />
      </div>
    }
  </div>
</ng-template>
